<template>
  <div class="home">
    <!-- 服务器错误提示界面 -->
    <div v-if="serverError" class="class-not-exists">
      <div class="not-exists-content">
        <h2>🔧 提示</h2>
        <p>服务器开小差了，请稍后再试！</p>
        <div class="button-group">
          <el-button type="primary" @click="goToLogin" size="large" style="margin-right: 20px;">前往登录</el-button>
          <el-button @click="goToRegister" size="large">前往注册</el-button>
        </div>
      </div>
    </div>
    <!-- 班级不存在的提示界面 -->
    <div v-else-if="!classExists" class="class-not-exists">
      <div class="not-exists-content">
        <h2>⚠️ 提示</h2>
        <p>该班级已删除或不存在！</p>
        <div class="button-group">
          <el-button type="primary" @click="goToLogin" size="large" style="margin-right: 20px;">前往登录</el-button>
          <el-button @click="goToRegister" size="large">前往注册</el-button>
        </div>
      </div>
    </div>
    <!-- 班级存在时的正常界面 -->
    <CorrectionSystem v-else :class-id="classId" />
  </div>
</template>

<script>
import CorrectionSystem from '@/components/pc/CorrectionSystemNew.vue'


export default {
  name: 'Home',
  components: {
    CorrectionSystem
  },
  data() {
    return {
      classExists: true,
      serverError: false
    }
  },
  computed: {
    classId() {
      // 将路由参数转换为数字类型
      return this.$route.params.classId ? Number(this.$route.params.classId) : null
    }
  },
  async created() {
    // 检查班级是否存在
    if (this.classId) {
      try {
        const response = await this.$http.get(`/classes/exists?classId=${this.classId}`);
        
        if (!response.data.exists) {
          // 班级不存在，设置标志位
          this.classExists = false;
        }
        // 如果班级存在，不做任何特殊处理，继续正常流程
      } catch (error) {
        console.error('检查班级存在性失败:', error);
        // 如果是500、502、503、504等服务器错误，显示服务器错误提示而不是班级不存在
        if (error.response && (error.response.status >= 500 && error.response.status < 600)) {
          this.serverError = true;
          this.classExists = null; // 不设置为false，而是用专门的服务器错误标志
        } else {
          // 其他错误（如404等）认为班级不存在
          this.classExists = false;
        }
      }
    }
  },
  methods: {
    goToLogin() {
      this.$router.push('/login');
    },
    goToRegister() {
      this.$router.push('/signin');
    }
  }
}
</script>

<style scoped>
.class-not-exists {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.not-exists-content {
  text-align: center;
  padding: 40px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.not-exists-content h2 {
  font-size: 2.5em;
  color: #f56c6c;
  margin-bottom: 15px;
}

.not-exists-content p {
  font-size: 1.2em;
  color: #606266;
  margin-bottom: 30px;
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 15px;
}
</style>